/**
 * Path Configuration
 * @apal/web-humanda
 *
 * Route paths for the standalone HUMANDA portal application.
 * Note: No /humanda prefix - routes are at root level.
 */

export const paths = {
  home: "/",
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  dashboard: {
    index: "/dashboard",
    hchs: {
      index: "/dashboard/hchs",
      dashboard: "/dashboard/hchs",
      metrics: "/dashboard/hchs/metrics",
      trends: "/dashboard/hchs/trends",
      details: (reportId: string) => `/dashboard/hchs/${reportId}`,
    },
    listings: {
      index: "/dashboard/listings",
      create: "/dashboard/listings/create",
      details: (listingId: string) => `/dashboard/listings/${listingId}`,
      edit: (listingId: string) => `/dashboard/listings/${listingId}/edit`,
      preview: (listingId: string) => `/dashboard/listings/${listingId}/preview`,
    },
    buyers: {
      index: "/dashboard/buyers",
      details: (buyerId: string) => `/dashboard/buyers/${buyerId}`,
    },
    reports: {
      history: "/dashboard/reports/history",
      generate: "/dashboard/reports/generate",
      view: (reportId: string) => `/dashboard/reports/${reportId}`,
    },
    marketplace: {
      index: "/dashboard/marketplace",
      detail: (id: string) => `/dashboard/marketplace/${id}`,
    },
    // REQ-BVDR-FE-7: legacy purchase path builders removed (buy-flow retired).
    broker: {
      index: "/dashboard/broker",
      clients: {
        index: "/dashboard/broker/clients",
        detail: (clientId: string) => `/dashboard/broker/clients/${clientId}`,
      },
      // REQ-BVDR-FE-5
      commissions: "/dashboard/broker/commissions",
      outreach: "/dashboard/broker/outreach",
    },
    billing: {
      index: "/dashboard/billing",
      plans: "/dashboard/billing/plans",
    },
    analytics: "/dashboard/analytics",
    help: {
      index: "/dashboard/help",
      article: (slug: string) => `/dashboard/help/${slug}`,
      contact: "/dashboard/help/contact",
    },
    account: {
      index: "/dashboard/account",
      profile: "/dashboard/account/profile",
      security: "/dashboard/account/security",
      notifications: "/dashboard/account/notifications",
      sessions: "/dashboard/account/sessions",
    },
  },
  admin: {
    accessLogs: "/dashboard/admin/access-logs",
    forensics: "/dashboard/admin/forensics",
  },
  // REQ-BVDR-FE-7: legacy top-level Stripe purchase callback builders removed.
  checkout: {
    subscriptionSuccess: "/checkout/subscription/success",
    subscriptionCancel: "/checkout/subscription/cancel",
  },
  errors: {
    notAuthorized: "/errors/not-authorized",
    notFound: "/errors/not-found",
    internalServerError: "/errors/internal-server-error",
  },
} as const;
